export default __webpack_public_path__ + "static/media/pulse-demo.c420b16c.png";